import { Component, OnInit, Injector, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BillStatus, TenantDashboardServiceProxy, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { SignalrService } from '@shared/service-proxies/signalr.service';
import { Subscription } from 'rxjs';
import { DashboardChartBase } from '../dashboard-chart-base';
import { WidgetComponentBase } from '../widget-component-base';


class DashboardTopStats extends DashboardChartBase {

  // totalProfit = 0; totalProfitCounter = 0;
  // newFeedbacks = 0; newFeedbacksCounter = 0;
  // newOrders = 0; newOrdersCounter = 0;
  // newUsers = 0; newUsersCounter = 0;

  // totalProfitChange = 76; totalProfitChangeCounter = 0;
  // newFeedbacksChange = 85; newFeedbacksChangeCounter = 0;
  // newOrdersChange = 45; newOrdersChangeCounter = 0;
  // newUsersChange = 57; newUsersChangeCounter = 0;

  // init(totalProfit, newFeedbacks, newOrders, newUsers) {
  //   this.totalProfit = totalProfit;
  //   this.newFeedbacks = newFeedbacks;
  //   this.newOrders = newOrders;
  //   this.newUsers = newUsers;
  //   this.hideLoading();
  // }
  totalBill = 0; totalBillCounter = 0;
  paidBill = 0; paidBillCounter = 0;
  onApproveBill = 0; onApproveBillCounter = 0;
  expiredBill = 0; expiredBillCounter = 0;
  cancelBill = 0; cancelBillCounter = 0;
  waitingForPaymentBill = 0; waitingForPaymentBillCounter = 0;
  notApproveBill = 0; notApproveBillCounter = 0;
  labelBill = 0; labelBillCounter = 0;
  calligraphyBill = 0; calligraphyBillCounter = 0;
  stockBill = 0; stockBillCounter = 0;
  transportBill = 0; transportBillCounter = 0;
  inCeremonyBill = 0; inCeremonyBillCounter = 0;

  totalBillChange = 0; totalBillChangeCounter = 0;
  paidBillChange = 0; paidBillChangeCounter = 0;
  onApproveBillChange = 0; onApproveBillChangeCounter = 0;
  expiredBillChange = 0; expiredBillChangeCounter = 0;
  cancelBillChange = 0; cancelBillChangeCounter = 0;
  waitingForPaymentBillChange = 0; waitingForPaymentBillChangeCounter = 0;
  notApproveBillChange = 0; notApproveBillChangeCounter = 0;
  labelBillChange = 0; labelBillChangeCounter = 0;
  calligraphyBillChange = 0; calligrphyBillChangeCounter = 0;
  stockBillChange = 0; stockBillChangeCounter = 0;
  transportBillChange = 0; transportBillChangeCounter = 0;
  inCeremonyBillChange = 0; inCeremonyBillChangeCounter = 0;

  deceasedNotApprove = 0; deceasedNotApproveCounter = 0;
  deceasedNotApproveImg = 0; deceasedNotApproveCounterImg = 0;
  ceremonyNotApprove = 0; ceremonyNotApproveCounter = 0;
  locationNotApprove = 0; locationNotApproveCounter = 0;
  condolenceMessageNotApprove = 0; condolenceMessageNotApproveCounter = 0;

  deceasedNotApproveChange = 0; deceasedNotApproveChangeCounter = 0;
  deceasedNotApproveChangeImg = 0; deceasedNotApproveChangeCounterImg = 0;
  ceremonyNotApproveChange = 0; ceremonyNotApproveChangeCounter = 0;
  locationNotApproveChange = 0; locationNotApproveChangeCounter = 0;
  condolenceMessageApproveChange = 0; condolenceMessageNotApproveChangeCounter = 0;


  charity = 0; charityCounter = 0;
  sacrifice = 0; sacrificeCounter = 0;
  flowerCrown = 0; flowerCrownCounter = 0;
  moneyBox = 0; moneyBoxCounter = 0;
  charityPrice = ""; charityPriceCounter = 0;
  sacrificePrice = ""; sacrificePriceCounter = 0;
  flowerCrownPrice = ""; flowerCrownPriceCounter = 0;
  moneyBoxPrice = ""; moneyBoxPriceCounter = 0;

  charityChange = 0; charityChangeCounter = 0;
  sacrificeChange = 0; sacrificeChangeCounter
  flowerCrownChange = 0; flowerCrownChangeCounter = 0;
  moneyBoxChange = 0; moneyBoxChangeCounter = 0;
  charityPriceChange = 0; charityPriceChangeCounter = 0;
  sacrificePriceChange = 0; sacrificePriceChangeCounter
  flowerCrownPriceChange = 0; flowerCrownPriceChangeCounter = 0;
  moneyBoxPriceChange = 0; moneyBoxPriceChangeCounter = 0;


  user = 0; userCounter = 0;
  onlineUser = 0; onlineUserCounter = 0;

  userChange = 0; userChangeCounter = 0;
  onlineUserChange = 0; onlineUserChangeCounter = 0;

  init(totalBill, paidBill, onApproveBill, expiredBill, cancelBill ,waitingForPaymentBill, notApproveBill, labelBill,
    calligraphyBill, stockBill, transportBill, inCeremonyBill) {
    this.totalBill = totalBill;
    this.paidBill = paidBill;
    this.onApproveBill = onApproveBill;
    this.expiredBill = expiredBill;
    this.cancelBill = cancelBill;
    this.waitingForPaymentBill = waitingForPaymentBill;
    this.notApproveBill = notApproveBill;
    this.labelBill = labelBill;
    this.calligraphyBill = calligraphyBill;
    this.stockBill = stockBill;
    this.transportBill = transportBill;
    this.inCeremonyBill = inCeremonyBill;
    this.hideLoading();
  }
}
export enum minimizeItem {
  totalBill = 1,
  paidBill = 2,
  onApproveBill = 3,
  expiredBill = 4,
  waitingForPaymentBill = 5,
  notApproveBill = 6,
  labelBill = 7,
  calligraphyBill = 8,
  stockBill = 9,
  transportBill = 10,
  inCeremonyBill = 11,
  condolenceMessageNotApprove = 12,
  ceremonyNotApprove = 13,
  deceasedNotApproveImg = 14,
  deceasedNotApprove = 15,
  cancelBill = 16
}

@Component({
  selector: 'app-widget-top-stats',
  templateUrl: './widget-top-stats.component.html',
  styleUrls: ['./widget-top-stats.component.css']
})
export class WidgetTopStatsComponent extends WidgetComponentBase implements OnInit, OnDestroy {

  dashboardTopStats: DashboardTopStats;
  today = false;
  minimizeItems: minimizeItem[] = [];
  minimizeItem = minimizeItem;
  stateFilter = undefined;
  mobileFilter = '';
  signalrSubscriber: Subscription;
  subscriber1: Subscription;
  subscriber2: Subscription;
  subscriber3: Subscription;
  subscriber4: Subscription;
  subscriber5: Subscription;
  subscriber6: Subscription;
  subscriber7: Subscription;
  subscriber8: Subscription;
  subscriber9: Subscription;

  constructor(injector: Injector,
    private _tenantDashboardServiceProxy: TenantDashboardServiceProxy,
    private router: Router,
    private signalrService: SignalrService
  ) {
    super(injector);
    this.dashboardTopStats = new DashboardTopStats();
  }

  ngOnDestroy(): void {
    this.signalrSubscriber.unsubscribe();
    this.subscriber1.unsubscribe();
    this.subscriber2.unsubscribe();
    this.subscriber3.unsubscribe();
    this.subscriber4.unsubscribe();
    this.subscriber5.unsubscribe();
    this.subscriber6.unsubscribe();
    this.subscriber7.unsubscribe();
    this.subscriber8.unsubscribe();
    this.subscriber9.unsubscribe();
  }

  ngOnInit() {
    this.loadNumberOfBill();
    this.router.navigate(['app/main/dashboardLoad'])
    this.signalrSubscriber = this.signalrService.dashboard.subscribe(() => {
      console.log('RefreshDashboardBySignalr.............................................');
      this.loadNumberOfBill();
    })
  }

  // loadTopStatsData() {
  //   this._tenantDashboardServiceProxy.getTopStats().subscribe((data) => {
  //     this.dashboardTopStats.init(data.totalProfit, data.newFeedbacks, data.newOrders, data.newUsers);
  //   });
  // }

  loadNumberOfBill() {
    this.subscriber1 = this._tenantDashboardServiceProxy.getNumberOfBill(true).subscribe(result => {
      this.dashboardTopStats.init(result.totalBIll, result.paidBill, result.onApproveBill, result.expiredBill, result.cancelBill , result.waitingForPaymentBill,
        result.notApproveBill, result.labelBill, result.calligraphyBill, result.stockBill, result.transportBill, result.inCeremonyBill);
      this.dashboardTopStats.totalBillCounter = result.totalBIll;
      this.dashboardTopStats.paidBillCounter = result.paidBill;
      this.dashboardTopStats.onApproveBillCounter = result.onApproveBill;
      this.dashboardTopStats.expiredBillCounter = result.expiredBill;
      this.dashboardTopStats.cancelBillCounter = result.cancelBill;
      this.dashboardTopStats.waitingForPaymentBillCounter = result.waitingForPaymentBill;
      // this.dashboardTopStats.notApproveBillCounter = result.notApproveBill;
      this.dashboardTopStats.labelBillCounter = result.labelBill;
      this.dashboardTopStats.calligraphyBillCounter = result.calligraphyBill;
      this.dashboardTopStats.stockBillCounter = result.stockBill;
      this.dashboardTopStats.transportBillCounter = result.transportBill;
      this.dashboardTopStats.inCeremonyBillCounter = result.inCeremonyBill;
      this.dashboardTopStats.paidBillChange = this.dashboardTopStats.totalBill == 0 ? 0 : (this.dashboardTopStats.paidBill * 100) / this.dashboardTopStats.totalBill;
      this.dashboardTopStats.onApproveBillChange = this.dashboardTopStats.totalBill == 0 ? 0 : (this.dashboardTopStats.onApproveBill * 100) / this.dashboardTopStats.totalBill;
      this.dashboardTopStats.expiredBillChange = this.dashboardTopStats.totalBill == 0 ? 0 : (this.dashboardTopStats.expiredBill * 100) / this.dashboardTopStats.totalBill;
      this.dashboardTopStats.cancelBillChange = this.dashboardTopStats.totalBill == 0 ? 0 : (this.dashboardTopStats.cancelBill * 100) / this.dashboardTopStats.totalBill;
      this.dashboardTopStats.waitingForPaymentBillChange = this.dashboardTopStats.totalBill == 0 ? 0 : (this.dashboardTopStats.waitingForPaymentBill * 100) / this.dashboardTopStats.totalBill;
      // this.dashboardTopStats.notApproveBillChange = this.dashboardTopStats.totalBill == 0 ? 0 : (this.dashboardTopStats.notApproveBill * 100) / this.dashboardTopStats.totalBill;
      this.dashboardTopStats.labelBillChange = this.dashboardTopStats.totalBill == 0 ? 0 : (this.dashboardTopStats.labelBill * 100) / this.dashboardTopStats.totalBill;
      this.dashboardTopStats.calligraphyBillChange = this.dashboardTopStats.totalBill == 0 ? 0 : (this.dashboardTopStats.calligraphyBill * 100) / this.dashboardTopStats.totalBill;
      this.dashboardTopStats.stockBillChange = this.dashboardTopStats.totalBill == 0 ? 0 : (this.dashboardTopStats.stockBill * 100) / this.dashboardTopStats.totalBill;
      this.dashboardTopStats.transportBillChange = this.dashboardTopStats.totalBill == 0 ? 0 : (this.dashboardTopStats.transportBill * 100) / this.dashboardTopStats.totalBill;
      this.dashboardTopStats.inCeremonyBillChange = this.dashboardTopStats.totalBill == 0 ? 0 : (this.dashboardTopStats.inCeremonyBill * 100) / this.dashboardTopStats.totalBill;
    })
    this.subscriber2 = this._tenantDashboardServiceProxy.getNumberOfCeremonyNotApprove(true).subscribe(result => {
      this.dashboardTopStats.ceremonyNotApprove = result;
      this.dashboardTopStats.ceremonyNotApproveCounter = result;
    })
    this.subscriber3 = this._tenantDashboardServiceProxy.getNumberOfDeceasedNotApprove(true).subscribe(result => {
      this.dashboardTopStats.deceasedNotApprove = result;
      this.dashboardTopStats.deceasedNotApproveCounter = result;
    })
    this.subscriber4 = this._tenantDashboardServiceProxy.getNumberOfDeceasedNotApproveImg(true).subscribe(result => {
      this.dashboardTopStats.deceasedNotApproveImg = result;
      this.dashboardTopStats.deceasedNotApproveCounterImg = result;
    })
    this.subscriber5 = this._tenantDashboardServiceProxy.getNumberOfCondolenceMessageNotApprove(true).subscribe(result => {
      this.dashboardTopStats.condolenceMessageNotApprove = result;
      this.dashboardTopStats.condolenceMessageNotApproveCounter = result;
    })
    this.subscriber6 = this._tenantDashboardServiceProxy.getNumberOfUser(true).subscribe(result => {
      this.dashboardTopStats.user = result;
      this.dashboardTopStats.userCounter = result;
    })
    this.subscriber7 = this._tenantDashboardServiceProxy.getNumberOfOnlineUser(true).subscribe(result => {
      this.dashboardTopStats.onlineUser = result;
      this.dashboardTopStats.onlineUserCounter = result;
    })
    this.subscriber9 = this._tenantDashboardServiceProxy.getNumberOfNotApproveBill(true).subscribe(result => {
      this.dashboardTopStats.notApproveBill = result;
      this.dashboardTopStats.notApproveBillCounter = result;
      this.dashboardTopStats.notApproveBillChange = this.dashboardTopStats.totalBill == 0 ? 0 : (this.dashboardTopStats.notApproveBill * 100) / this.dashboardTopStats.totalBill;
    })
    this.getNumberOfPlans();
  }

  getNumberOfPlans() {
    this.subscriber8 = this._tenantDashboardServiceProxy.getNumberOfPlans(this.today, true).subscribe(result => {
      this.dashboardTopStats.charity = result.charityCount;
      this.dashboardTopStats.sacrifice = result.sacrificeCount;
      this.dashboardTopStats.flowerCrown = result.flowerCrownCount;
      this.dashboardTopStats.moneyBox = result.moneyBoxCount;
      this.dashboardTopStats.charityPrice = result.charityPrice;
      this.dashboardTopStats.sacrificePrice = result.sacrificePrice;
      this.dashboardTopStats.flowerCrownPrice = result.flowerCrownPrice;
      this.dashboardTopStats.moneyBoxPrice = result.moneyBoxPrice;

      this.dashboardTopStats.charityCounter = result.charityCount;
      this.dashboardTopStats.sacrificeCounter = result.sacrificeCount;
      this.dashboardTopStats.flowerCrownCounter = result.flowerCrownCount;
      this.dashboardTopStats.moneyBoxCounter = result.moneyBoxCount;
      this.dashboardTopStats.charityPriceCounter = +result.charityPrice;
      this.dashboardTopStats.sacrificePriceCounter = +result.sacrificePrice;
      this.dashboardTopStats.flowerCrownPriceCounter = +result.flowerCrownPrice;
      this.dashboardTopStats.moneyBoxPriceCounter = +result.moneyBoxPrice;
    })
  }

  getWidth(input) {
    let x = (input * 100) / this.dashboardTopStats.totalBill;
    return x + "%"
  }

  navigate() {
    this.router.navigate(['/app/main/bills/fsbills']);
  }
  navigateNotApproveBill(){
    this.router.navigate(['/app/main/bills/fsbills'], {
      queryParams: {
        notApproveBill: true,
      }
    });
  }
  navigateWaitingForPaymentBill(){
    this.router.navigate(['/app/main/bills/fsbills'], {
      queryParams: {
        waitingForPaymentBill: true,
      }
    });
  }
  navigateExpiredBill() {
    this.router.navigate(['/app/main/bills/fsbills'], {
      queryParams: {
        expiredBill: true,
      }
    });
  }
  navigateCancelBill() {
    this.router.navigate(['/app/main/bills/fsbills'], {
      queryParams: {
        cancelBill: true,
      }
    });
  }
  navigateOnApproveBill() {
    this.router.navigate(['/app/main/bills/fsbills'], {
      queryParams: {
        onApproveBill: true,
      }
    });
  }
  navigatePaidBill() {
    this.router.navigate(['/app/main/reports/billReport/bill-report'], {
      queryParams: {
        paidBill: true,
      }
    });
  }
  // navigateLabelBill() {
  //   this.router.navigate(['/app/main/bills/bills'], {
  //     queryParams: {
  //       labelBill: true,
  //     }
  //   });
  // }
  navigateCalligraphyBill() {
    this.router.navigate(['/app/main/action/action'], {
      queryParams: {
        calligraphyBill: true,
      }
    });
  }
  navigateStockBill() {
    this.router.navigate(['/app/main/action/action'], {
      queryParams: {
        stockBill: true,
      }
    });
  }
  navigateTransportBill() {
    this.router.navigate(['/app/main/action/action'], {
      queryParams: {
        transportBill: true,
      }
    });
  }
  navigateInCeremonyBill() {
    this.router.navigate(['/app/main/action/action'], {
      queryParams: {
        inCeremonyBill: true,
      }
    });
  }
  navigateCeremony() {
    this.router.navigate(['/app/main/ceremonies/ceremonies'], {
      queryParams: {
        navigateByDashboard: true,
      }
    });
  }
  navigateDeceased() {
    this.router.navigate(['/app/main/deceaseds/deceaseds'], {
      queryParams: {
        navigateByDashboard: true,
      }
    });
  }
  navigateDeceasedImg() {
    this.router.navigate(['/app/main/deceaseds/deceaseds'], {
      queryParams: {
        navigateByDashboardForImg: true,
      }
    });
  }
  navigateCondolenceMessage() {
    this.router.navigate(['/app/main/condolenceMessages/condolenceMessages'], {
      queryParams: {
        navigateByDashboard: true,
      }
    });
  }
  navigateContact() {
    this.router.navigate(['/app/main/contacts/contacts']);
  }
  seelectTodayOrAll(today) {
    this.today = today;
    this.getNumberOfPlans();
  }
  minimize(item) {
    console.log('item', item);
    this.minimizeItems.push(item)
    console.log('this.minimizeItems', this.minimizeItems);
    let hide = document.getElementById(item);
    hide.style.display = 'none';
  }

  select(item) {
    console.log('item', item);
    this.minimizeItems = this.minimizeItems.filter(record => {
      return record !== item
    })
    console.log('this.minimizeItems', this.minimizeItems);
    let hide = document.getElementById(item);
    hide.style.display = 'block';

    setTimeout(() => {
      this.stateFilter = undefined;
    }, 1);
  }
}
